(ns frontend.view.nev.kyc.process.checkbox-editor
  (:require
   [ui.components.input.checkbox :as checkbox]))

;; Ad-hoc simple checkbox to avoid regression if changing existing checkbox component that is used elsewhere
(defn view
  [{:keys [question-meta question-attribute
           answers-atom on-change
           lang-kw save! read-only?]}]
  (let [checked? (get @answers-atom question-attribute)
        label (get-in question-meta [:translations lang-kw])]

    [:div
     {:class "mb-3"}
     [:label
      {:class "flex items-start cursor-pointer text-[0.875rem] font-bold leading-[1rem]"}
      [:div
       {:class ""}
       [checkbox/view
        {:value checked?
         :disabled? read-only?
         :on-change on-change}]]
      [:span
       {:class "ml-2"}
       label]]]))
